import React from 'react';
import PropTypes from 'prop-types';
import { BaasicCheckboxTemplate } from 'themes/components';
const BaasicCheckbox = function(props) {
	return <BaasicCheckboxTemplate {...props} />;
};

BaasicCheckbox.propTypes = {
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	onChangeCallback: PropTypes.func,
	checked: PropTypes.bool,
	disabled: PropTypes.bool,
	className: PropTypes.string,
	label: PropTypes.string,
	t: PropTypes.func,
};

BaasicCheckbox.defaultProps = {
	disabled: false,
	label: '',
};

export default BaasicCheckbox;



// WEBPACK FOOTER //
// ./src/core/components/forms/BaasicCheckbox.js